import { useState, useCallback } from 'react';
import { d211Api, FD110 } from '../../../services/d211Api';

export function useD211Navigation() {
  const [list, setList] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const fetchList = useCallback(async (keyword?: string) => {
    try {
      const result = await d211Api.list(1, 500, keyword);
      const ids = result.data.map((r: FD110) => r.fd110_01);
      setList(ids);
      if (ids.length > 0 && currentIdx < 0) {
        setCurrentIdx(0);
      }
      return ids;
    } catch {
      return [];
    }
  }, [currentIdx]);

  const setCurrentByKey = useCallback((key: string) => {
    const idx = list.findIndex(id => id === key);
    if (idx >= 0) setCurrentIdx(idx);
  }, [list]);

  const hasPrev = currentIdx > 0;
  const hasNext = currentIdx >= 0 && currentIdx < list.length - 1;

  const goFirst = useCallback(() => {
    if (list.length === 0) return null;
    setCurrentIdx(0);
    return list[0];
  }, [list]);

  const goLast = useCallback(() => {
    if (list.length === 0) return null;
    const idx = list.length - 1;
    setCurrentIdx(idx);
    return list[idx];
  }, [list]);

  const goPrev = useCallback(() => {
    if (!hasPrev) return null;
    const idx = currentIdx - 1;
    setCurrentIdx(idx);
    return list[idx];
  }, [hasPrev, currentIdx, list]);

  const goNext = useCallback(() => {
    if (!hasNext) return null;
    const idx = currentIdx + 1;
    setCurrentIdx(idx);
    return list[idx];
  }, [hasNext, currentIdx, list]);

  return {
    list, currentIdx, hasPrev, hasNext,
    fetchList, setCurrentByKey,
    goFirst, goLast, goPrev, goNext,
  };
}
